// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__11L3V","footer":"Form_footer__jBAX-"};